export default __webpack_public_path__ + "static/media/star_2.88169e1f.svg";